export const routeIds = {
  STOREFRONT_BY_ID: 'STOREFRONT_BY_ID'
}